import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import ApproveModal from "../../../Components/Common/ApproveModal";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";

import Flatpickr from "react-flatpickr";
import Select from "react-select";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";
import handleValidDate from "../../../helpers/utils/handleValidDate";
import handleValidDateTime from "../../../helpers/utils/handleValidDateTime";
import handleValidTime from "../../../helpers/utils/handleValidTime";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { getEmployee, resetEmployeeState } from "../../../store/employee/action";
import { resetLoanTermState, getLoanTerm } from "../../../store/loanTerm/action";
import { resetLoanState, getLoan as onGetLoans, addNewLoan as onAddNewLoan, updateLoan as onUpdateLoan, deleteLoan as onDeleteLoan, getLoanLoading } from "../../../store/loan/action";
import { getAccAccount, resetAccAccountState } from "../../../store/accAccount/action";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import { setBranchSelect, setCompanySelect } from "../../../store/actions";

const Loan = () => {
  const [modal, setModal] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, loans, isLoanCreated, isLoanSuccess, loading, error, employees, employeeLoading, loanTerms, loanTermLoading, companies, companyLoading, clientLoading, clients, accAccounts, accAccountLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    loans: state.Loan.loans,
    isLoanCreated: state.Loan.isLoanCreated,
    isLoanSuccess: state.Loan.isLoanSuccess,
    loading: state.Loan.loading,
    employees: state.Employee.employees,
    employeeLoading: state.Employee.loading,
    error: state.Loan.error,
    loanTerms: state.LoanTerm.loanTerms,
    loanTermLoading: state.LoanTerm.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    clientLoading: state.Client.loading,
    clients: state.Client.clients,
    accAccounts: state.AccAccount.accAccounts,
    accAccountLoading: state.AccAccount.loading,
  }));

  const [loanList, setLoanList] = useState([]);
  const [loan, setLoan] = useState([]);
  const [loanPayment, setLoanPayment] = useState({});
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);
  const [approveModal, setApproveModal] = useState(false);
  const [loanTermList, setLoanTermList] = useState([]);
  const [accountingList, setAccountingList] = useState([]);

  const [info, setInfo] = useState([]);
  const [isSearch, setIsSearch] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isPayment, setIsPayment] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [amount, setAmount] = useState(0);
  const [period, setPeriod] = useState(0);
  const [maxAmount, setMaxAmount] = useState(0);
  const [maxPeriod, setMaxPeriod] = useState(0);
  const [interest, setInterest] = useState(0);
  const [interestType, setInterestType] = useState("");
  const [instalmentData, setInstalmentData] = useState([]);
  const [paymentData, setPaymentData] = useState([]);
  const [paymentDataList, setPaymentDataList] = useState([]);
  const [instalmentValue, setInstalmentValue] = useState([]);
  const [dateValue, setDateValue] = useState();
  const [amountValue, setAmountValue] = useState(0);
  const [accValue, setAccValue] = useState({});
  const [companyList, setCompanyList] = useState([]);
  const [clientList, setClientList] = useState([]);

  const [positionMessage, setPositionMessage] = useState("");
  const [defaultCompanyId, setDefaultCompanyId] = useState(null);

  const [printDoc, setPrintDoc] = useState([]);

  const statusActiveData = [
    {
      options: [
        { label: "DRAFT", value: "1" },
        { label: "ACTIVE", value: "2" },
        { label: "COMPLETED", value: "3" },
        { label: "INACTIVE", value: "4" },
      ],
    },
  ];

  useEffect(() => {
    if (companySelected) {
      setPositionMessage(`${userData?.user?.user_department && userData?.user?.user_department?.name}, ${userData?.user?.user_position && userData?.user?.user_position?.name}`);
      dispatch(resetLoanState());
      dispatch(onGetLoans({ companyId: companySelected?.value ?? "" }));
      handleGetEmployee(companySelected?.value ?? "");
      handleGetAccAccount(companySelected?.value ?? "");
    }
  }, [companySelected]);

  const handleGetEmployee = (companyId) => {
    dispatch(resetEmployeeState());
    dispatch(getEmployee({ companyId: companyId, status: 2 }));
  };

  const handleGetAccAccount = (companyId) => {
    dispatch(resetAccAccountState());
    dispatch(getAccAccount({ companyId: companyId, status: 2 }));
  };

  const onClickDelete = (loan) => {
    setLoan(loan);
    setDeleteModal(true);
  };

  const handleDeleteLoan = () => {
    if (loan) {
      dispatch(onDeleteLoan(loan));
      setDeleteModal(false);
    }
  };

  // useEffect(() => {
  //   setLoanList(loans);
  // }, [loans]);

  useEffect(() => {
    if (!isEmpty(loans)) {
      let filteredLoans = loans;
      if (activeTypeTab !== "all") {
        filteredLoans = loans.filter((loan) => loan.loan_status.name === activeTypeTab);
      }
      setLoanList(filteredLoans.map((el) => ({ ...el, isChecked: false })));
      setIsEdit(false);
      setInfo(loans[0]);
    }
  }, [loans]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "loan_user",
        label: "Nama",
        isSelected: true,
        data: [],
      },

      {
        id: "rates",
        label: "Jumlah",
        isSelected: true,
        data: [],
      },
      {
        id: "startat",
        label: "Tanggal",
        isSelected: true,
        data: [],
      },
      {
        id: "loan_term",
        label: "Jangka Waktu",
        isSelected: true,
        data: [],
      },
    ];

    if (loanList.length > 0) {
      loanList.forEach((data) => {
        if (data.isChecked) {
          Object.entries(data).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);
            if (doc) {
              if (doc.id === "loan_user") {
                doc.data.push(value?.name ?? "-");
              } else if (doc.id === "loan_term") {
                const period = parseInt(data.period);
                const val = value?.name ?? "-";
                doc.data.push(`${val}-${period}`);
              } else if (doc.id === "rates") {
                doc.data.push(currencyFormat(value));
              } else if (doc.id === "startat") {
                doc.data.push(handleValidDate(value));
              } else {
                doc.data.push(value ?? "-");
              }
            }
          });
        }
      });
    }

    setPrintDoc(dataDoc);
  }, [loanList]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredLoans = loans;
      if (type !== "all") {
        filteredLoans = loans.filter((loan) => loan.loan_status.name === type);
      }
      setLoanList(filteredLoans);
    }
  };

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    if (!isEmpty(employees)) {
      var data = [];
      var opt = [];
      employees.forEach((item, key) => {
        const name = item.name;
        const userId = item.userId;
        const companyId = item.companyId;
        const location = item.employee_location;
        const position = item.employee_position;
        const department = item.employee_department;
        const position_name = item?.employee_user && item?.employee_user?.user_position ? item?.employee_user?.user_position?.name : "Not set";
        var obj = {
          label: name + " - " + position_name,
          value: userId,
          companyId: companyId,
          location: location,
          position: position,
          department: department,
          userId: userId,
        };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setEmployeeList(data);
    }
  }, [employees]);

  useEffect(() => {
    if (!isEmpty(accAccounts)) {
      var data = [];
      var opt = [];
      accAccounts.forEach((item, key) => {
        const name = item.name;
        const code = item.code;
        const id = item.id;
        var obj = { label: code + " " + name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setAccountingList(data);
    }
  }, [accAccounts]);

  useEffect(() => {
    if (paymentData.length > 0) {
      var data = [];
      var opt = [{ label: "Select All", value: "all" }];
      paymentData.forEach((item, key) => {
        const period = Math.round(item.period);
        const id = item.id;
        var obj = { label: "Period " + period, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setPaymentDataList(data);
    }
  }, [paymentData]);

  useEffect(() => {
    if (!isEmpty(loanTerms)) {
      var data = [];
      var opt = [];
      loanTerms.forEach((item, key) => {
        const name = item.name;
        const period = item.period;
        const amount = item.amount;
        const interest = item.interest;
        const interest_type = item.interest_type;
        const id = item.id;
        var obj = {
          label: name,
          value: id,
          period: Math.round(period),
          amount: amount,
          interest: interest,
          interest_type: interest_type,
        };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setLoanTermList(data);
    }
  }, [loanTerms]);

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    if (period > 0) {
      let instalment = [];
      for (let i = 1; i <= period; i++) {
        if (interestType === "Flat") {
          let am = amount / period;
          let intr = (interest / 100) * amount;
          instalment.push({
            period: Math.round(i),
            amount: am,
            interest: intr,
            total: am + intr,
          });
        } else {
          let am = amount / period;
          let intr = (amount - (i - 1) * am) * (interest / 100);
          instalment.push({
            period: Math.round(i),
            amount: am,
            interest: intr,
            total: am + intr,
          });
        }
      }
      setInstalmentData(instalment);
    } else {
      setInstalmentData([]);
    }
  }, [amount, period, interest, interestType, isPayment]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setLoan(null);
      setIsPayment(false);
    } else {
      setModal(true);
    }
  }, [dispatch, modal]);

  const toggleApprove = useCallback(() => {
    if (approveModal) {
      setApproveModal(false);
      setLoan(null);
    } else {
      setApproveModal(true);
    }
  }, [dispatch, approveModal]);

  const handleLoanClick = useCallback(
    (arg) => {
      const data = arg;
      setAmount(data.amount);
      setMaxAmount(data.loan_term.amount);
      setPeriod(data.period);
      setMaxPeriod(data.loan_term.period);
      setInterest(data.interest);
      setInterestType(data.loan_term.interest_type);
      setInstalmentData(data.loan_instalment);
      setLoan({
        id: data.id,
        description: data.description,
        startat: data.startat,
        period: Math.round(data.period),
        amount: data.amount,
        interest: data.interest,
        employee: {
          label: data.loan_user.name,
          value: data.loan_user.id,
          companyId: data.loan_user.companyId,
          userId: data.loan_user.userId,
        },
        loan_term: {
          label: data.loan_term.name,
          value: data.loan_term.id,
          interest_type: data.loan_term.interest_type,
        },
      });
      setIsEdit(true);
      toggle();
    },
    [toggle]
  );

  const handlePaymentClick = useCallback(
    (data) => {
      const loanInstalment = [...data.loan_instalment].sort((a, b) => a.period - b.period);
      setInstalmentValue([]);
      setAccValue({});
      setAmountValue(0);
      setPaymentData(loanInstalment);
      setLoanPayment(data);
      setIsPayment(true);
      toggle();
    },
    [toggle]
  );

  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteLoan(element.value));
    });
    checkall.checked = false;
  };

  const onClickApprove = (arg) => {
    const data = arg;
    setLoan(arg);
    setApproveModal(true);
  };

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = loanList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setLoanList(updated);
    setIsCheckAll(allChecked);
  };

  // Column
  const columns = useMemo(
    () => [
      {
        id: "#",
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <input
                type="checkbox"
                className="dataCheckbox me-2 form-check-input"
                checked={data.isChecked}
                onChange={() => {
                  const updatedData = loanList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
                  setLoanList(updatedData);
                }}
              />
            </div>
          );
        },
      },
      {
        Header: " ",
        filterable: false,
        Cell: (cellProps) => {
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <Link
                to="#"
                className="btn-icon btn btn-sm btn-light"
                onClick={() => {
                  setInfo(cellProps.row.original);
                }}
              >
                <i className="ri-eye-line fs-15"></i>
              </Link>
              {cellProps.row.original.statusId === 1 && (
                <>
                  <Link
                    to="#"
                    className={userType === "admin" ? "btn-icon btn btn-sm btn-light edit-item-btn" : userRole && userRole.split(",").indexOf("updateLoan") !== -1 ? "btn-icon btn btn-sm btn-light edit-item-btn" : "btn-icon btn btn-sm btn-light edit-item-btn d-none"}
                    onClick={() => {
                      const loanData = cellProps.row.original;
                      setIsPayment(false);
                      handleLoanClick(loanData);
                    }}
                  >
                    <i className="ri-edit-2-line fs-15"></i>
                  </Link>
                  <Link
                    to="#"
                    className={userType === "admin" ? "btn-icon btn btn-sm btn-soft-danger remove-item-btn" : userRole && userRole.split(",").indexOf("deleteLoan") !== -1 ? "btn-icon btn btn-sm btn-soft-danger remove-item-btn" : "btn-icon btn btn-sm btn-soft-danger remove-item-btn d-none"}
                    onClick={() => {
                      const loanData = cellProps.row.original;
                      onClickDelete(loanData);
                    }}
                  >
                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                  </Link>
                </>
              )}
              {cellProps.row.original.statusId === 2 && (
                <Link
                  to="#"
                  className={userType === "admin" ? "btn btn-sm btn-soft-info fs-12 me-0" : userRole && userRole.split(",").indexOf("createLoanPayment") !== -1 ? "btn btn-sm btn-soft-info fs-12 me-0" : "btn btn-sm btn-soft-info fs-12 me-0 d-none"}
                  onClick={() => {
                    const loanData = cellProps.row.original;
                    handlePaymentClick(loanData);
                  }}
                >
                  <i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-0"></i> Payment
                </Link>
              )}
              {cellProps.row.original.statusId === 1 && (
                <button
                  className={userType === "admin" ? "btn-label btn btn-sm btn-soft-success fs-12 me-0" : userRole && userRole.split(",").indexOf("approveLoan") !== -1 ? "btn-label btn btn-sm btn-soft-success fs-12 me-0" : "btn-label btn btn-sm btn-soft-success fs-12 me-0 d-none"}
                  onClick={() => {
                    let data = cellProps.row.original;
                    onClickApprove(data);
                  }}
                >
                  <i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-0"></i>Approve
                </button>
              )}
            </div>
          );
        },
      },
      {
        Header: "Karyawan",
        accessor: "loan_user.name",
        filterable: true,
      },
      {
        Header: "Jumlah",
        accessor: "rates",
        filterable: true,
        Cell: (data) => <> {currencyFormat(data.row.original.amount)} </>,
      },
      {
        Header: "Tanggal",
        accessor: "startat",
        filterable: true,
        Cell: (data) => <> {handleValidDate(data.row.original.startat)} </>,
      },
      {
        Header: "Jangka Waktu",
        accessor: "loan_term.name",
        filterable: true,
        Cell: (data) => {
          return (
            <div>
              <div className="mb-1">{data.row.original.loan_term.name}</div>
              <div className="badge text-uppercase badge-soft-info">{parseInt(data.row.original.period)} Months </div>
            </div>
          );
        },
      },
      {
        Header: "Status",
        accessor: "loan_status.name",
        filterable: true,
        Cell: (cell) => {
          switch (cell.value) {
            case "DRAFT":
              return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
            case "ACTIVE":
              return <span className="badge text-uppercase badge-soft-info">{cell.value}</span>;
            case "COMPLETED":
              return <span className="badge text-uppercase badge-soft-success">{cell.value}</span>;
            case "INACTIVE":
              return <span className="badge text-uppercase badge-soft-danger">{cell.value}</span>;
            default:
              return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
          }
        },
      },
    ],
    [loanList, handleLoanClick, handlePaymentClick, userRole, userType, isCheckAll]
  );

  const [filterDate, setFilterDate] = useState(null);

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    const resetChecked = loanList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setLoanList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
    setGlobalFilterValue(value ?? "");
  }, 300);

  const memoizedData = useMemo(() => loanList, [loanList]);
  //TABLE
  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: memoizedData,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 10,
        selectedRowIds: 0,
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }

    var reason = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      reason: reason,
      companyId: companySelected?.value ?? "",
    };
    dispatch(onGetLoans(param));
  }

  const handleResetFilter = () => {
    setFilterDate(null);
    setLoanList([]);
    setStatusActive([]);
    setSearchValue("");
    setGlobalFilter(undefined);
    setGlobalFilterValue("");
    dispatch(resetLoanState());
    dispatch(onGetLoans({ companyId: companySelected?.value ?? "" }));
  };

  const handleSubmitAddPayment = () => {
    if (instalmentValue.length > 0 && amountValue > 0 && accValue.value) {
      dispatch(getLoanLoading());
      loanPayment.accPaymentId = accValue.value;
      loanPayment.transactionat = dateValue;
      loanPayment.instalment = instalmentValue;
      loanPayment.setAccPayment = true;
      loanPayment.setApprove = false;
      loanPayment.amount = amountValue;
      dispatch(onUpdateLoan(loanPayment));
      toggle();
    } else toast.error("Silahkan lengkapi data pembayaran", { autoClose: 3000 });
  };

  const validationAccPayment = useFormik({
    enableReinitialize: true,
    initialValues: {
      account: "",
      transactionat: moment().format("YYYY/MM/DD"),
    },
    validationSchema: Yup.object({
      transactionat: Yup.string().required("Please pick loan date"),
      account: Yup.object().required("Please enter payment account").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getLoanLoading());
      if (loan) {
        loan.accPaymentId = values.account.value;
        loan.transactionat = values.transactionat;
        loan.setAccPaymentApprove = true;
        loan.setApprove = false;
        dispatch(onUpdateLoan(loan));
        setApproveModal(false);
      }
      validationAccPayment.resetForm();
      setApproveModal(false);
    },
  });

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      description: (loan && loan.description) ?? "",
      startat: loan && loan.startat,
      employee: loan && loan.employee,
      termId: loan && loan.loan_term,
      period: (loan && loan.period) || 0,
      amount: (loan && loan.amount) || 0,
      client: (loan && loan.client) || clientSelected,
      company: (loan && loan.company) || companySelected,
    },
    validationSchema: Yup.object({
      period: Yup.string().required("Please Enter Period"),
      amount: Yup.string().required("Please Enter Amount"),
      employee: Yup.object().required("Please Pick employee"),
      termId: Yup.object().required("Please Pick Term"),
    }),
    onSubmit: (values) => {
      dispatch(getLoanLoading());
      if (isEdit) {
        const updateLoan = {
          id: loan ? loan.id : 0,
          statusId: 1,
          description: values.description,
          period: values.period,
          amount: values.amount,
          interest: values.termId.interest,
          interest_type: values.termId.interest_type,
          startat: values.startat,
          userId: values.employee.value,
          termId: values.termId.value,
          clientId: values.client.value,
          companyId: values.company.value,
          instalment: instalmentData,
        };
        dispatch(onUpdateLoan(updateLoan));
        validation.resetForm();
      } else {
        const newLoan = {
          statusId: 1,
          description: values.description,
          period: values.period,
          amount: values.amount,
          interest: values.termId.interest,
          interest_type: values.termId.interest_type,
          startat: values.startat,
          userId: values.employee.userId,
          termId: values.termId.value,
          clientId: values.client.value,
          companyId: values.company.value,
          instalment: instalmentData,
        };
        dispatch(onAddNewLoan(newLoan));
        validation.resetForm();
      }
      toggle();
    },
  });

  document.title = "Pinjaman | Enterprise Resources Planning";

  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={loanList} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteLoan} onCloseClick={() => setDeleteModal(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="Keuangan" pageTitle="Pinjaman Karyawan" loading={loading}>
          <div className="flex-shrink-0">
            <button
              type="button"
              className={userType === "admin" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createLoan") !== -1 ? "btn btn-primary add-btn me-2" : "btn btn-primary add-btn me-2 d-none"}
              id="create-btn"
              onClick={() => {
                setLoan("");
                setIsEdit(false);
                setIsPayment(false);
                setAmount(0);
                setPeriod(0);
                setInterest(0);
                setInterestType("");
                setInstalmentData([]);
                toggle();
              }}
            >
              <i className="ri-wallet-3-line me-1 align-bottom fs-14"></i> Tambah
            </button>
            <button type="button" className="btn btn-success" onClick={() => setIsExportCSV(true)}>
              <i className="ri-file-download-line me-1 align-bottom fs-14"></i> Export
            </button>
            {/* <button
                      className="btn btn-soft-danger"
                      onClick={() => setDeleteModalMulti(true)}>
                      <i className="ri-delete-bin-5-line me-1 align-bottom fs-15"></i>    Delete
                    </button> */}
          </div>
        </BreadCrumb>
        <Row>
          <Col lg={8}>
            <Card id="loanList">
              <CardBody className="pt-0">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"
                      >
                        <i className="ri-wallet-3-line me-1 align-bottom fs-14"></i>SEMUA PINJAMAN
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#"
                      >
                        <i className="ri-information-line me-1 align-bottom fs-14"></i> DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("3", "ACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> ACTIVE
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("4", "COMPLETED");
                        }}
                        href="#"
                      >
                        <i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i> COMPLETED
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "5" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("5", "INACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i> INACTIVE
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={2}>
                            <div className="me-2 mb-2 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={3}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Cari...`}
                                value={searchValue ?? ""}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={3} className="col-xxl-3">
                            <div className="search-box mb-2">
                              <Flatpickr
                                className="form-control"
                                id="datepicker-publish-input"
                                placeholder="Pilih Tanggal"
                                options={{
                                  mode: "range",
                                  dateFormat: "Y/m/d",
                                }}
                                onChange={(selectedDates, dateStr) => {
                                  setFilterDate(dateStr);
                                }}
                              />
                              <i className="bx bx-calendar-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={3} className="col-xxl-2">
                            <div className="me-2 mb-2 col-12">
                              <Select
                                placeholder="Status"
                                onChange={(e) => {
                                  setStatusActive(e);
                                }}
                                options={statusActiveData}
                                name="choices-single-default"
                              ></Select>
                            </div>
                          </Col>
                          <Col sm={2}>
                            <div className="hstack gap-2">
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleFilter();
                                }}
                              >
                                <i className="ri-search-line align-bottom fs-16"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleResetFilter();
                                }}
                              >
                                <i className="mdi mdi-restore align-bottom fs-18"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th {...column.getSortByToggleProps()} className={"" + generateFilterable(column)} key={index}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button color="light" onClick={previousPage} disabled={!canPreviousPage}>
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={nextPage} disabled={!canNextPage}>
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {isPayment ? "Payment" : !!isEdit ? "Ubah Pinjaman" : "Tambah Pinjaman"}
                  </ModalHeader>

                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      if (isPayment) {
                        handleSubmitAddPayment();
                      }
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    {isPayment ? (
                      <ModalBody>
                        <div className="row gx-4">
                          <div className="col-lg-5">
                            <div className="mb-3">
                              <Label htmlFor="periode" className="form-label">
                                Karyawan
                              </Label>
                              <h5>{loanPayment && loanPayment.loan_user.name}</h5>
                            </div>
                            <div className="mb-3">
                              <Label htmlFor="periode" className="form-label">
                                Periode Pinjaman
                              </Label>
                              <Select
                                name="instalment"
                                value={instalmentValue}
                                placeholder="Enter Periode"
                                isMulti
                                onChange={(opt, { option }) => {
                                  let newOpts = opt;
                                  if (option && option.value === "all") {
                                    let filteredOptions = clone(paymentDataList);
                                    filteredOptions = filteredOptions[0].options.filter((filteredOption) => !newOpts.includes(filteredOption));
                                    newOpts = newOpts.concat(filteredOptions).filter((newOpt) => newOpt.value !== "all");
                                  }
                                  setInstalmentValue(newOpts);
                                }}
                                options={paymentDataList}
                              ></Select>
                            </div>
                            <Row>
                              <div className="mb-3 col-lg-6">
                                <Label htmlFor="date-field" className="form-label">
                                  Tanggal Pembayaran
                                </Label>
                                <Flatpickr
                                  name="startat"
                                  className="form-control"
                                  placeholder="Select  date"
                                  options={{
                                    enableTime: false,
                                    dateFormat: "Y/m/d",
                                  }}
                                  value={dateValue}
                                  onChange={(o, e) => {
                                    setDateValue(e);
                                  }}
                                />
                              </div>
                              <div className="mb-3 col-lg-6">
                                <Label htmlFor="amount-field" className="form-label">
                                  Jumlah Pembayaran
                                </Label>
                                <Input
                                  name="amount"
                                  id="amount-field"
                                  className="form-control"
                                  placeholder="Enter amount"
                                  type="number"
                                  onFocus={(e) => e.target.select()}
                                  onChange={(e) => {
                                    setAmountValue(Number(e.target.value));
                                  }}
                                  onBlur={validation.handleBlur}
                                  value={amountValue}
                                />
                              </div>
                            </Row>
                            <div className="mb-3 col-lg-12">
                              <label className="form-label" htmlFor="account">
                                Akun Pembayaran
                              </label>
                              <Select
                                name="account"
                                value={accValue}
                                placeholder="Enter account"
                                onChange={(e) => {
                                  setAccValue(e);
                                }}
                                options={accountingList}
                              ></Select>
                            </div>
                          </div>
                          <div className="col">
                            <table className="table border table-responsive table-striped fs-13 mb-3">
                              <thead className="table-light">
                                <tr>
                                  <th>Periode</th>
                                  <th>Jumlah</th>
                                  <th>Bunga</th>
                                  <th>Total</th>
                                  <th>Status</th>
                                </tr>
                              </thead>
                              <tbody>
                                {paymentData.map((instalment, i) => {
                                  return (
                                    <tr key={i}>
                                      <td>{Math.round(instalment.period)}</td>
                                      <td>{currencyFormat(instalment.amount)}</td>
                                      <td>{currencyFormat(instalment.interest)}</td>
                                      <td>{currencyFormat(instalment.total)}</td>
                                      <td>{instalment.status && <span className="badge text-uppercase badge-soft-info">{instalment.status}</span>}</td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </ModalBody>
                    ) : (
                      <ModalBody>
                        <div className="row gx-4">
                          <div className="col-lg-4">
                            <div className="mb-3">
                              <Label htmlFor="client-field" className="form-label">
                                Grup Usaha&nbsp;
                                {clientLoading && (
                                  <Spinner color="primary" size="sm">
                                    Loading...
                                  </Spinner>
                                )}
                              </Label>
                              <Select
                                name="client"
                                value={validation.values.client}
                                isDisabled={userType === "admin" || userType === "client" ? false : true}
                                placeholder="Pilih Grup Usaha"
                                onChange={(e) => {
                                  validation.setFieldValue("client", e);
                                }}
                                options={clientList}
                              ></Select>
                            </div>
                            <div className="mb-3">
                              <Label htmlFor="company-field" className="form-label">
                                Perusahaan&nbsp;
                                {companyLoading && (
                                  <Spinner color="primary" size="sm">
                                    Loading...
                                  </Spinner>
                                )}
                              </Label>
                              <Select
                                name="company"
                                value={validation.values.company}
                                placeholder="Pilih Perusahaan"
                                isDisabled={userType === "admin" || userType === "client" ? false : true}
                                onChange={(e) => {
                                  dispatch(setBranchSelect(null));
                                  dispatch(setCompanySelect(e));
                                  validation.setFieldValue("company", e);
                                  handleGetEmployee(e.value);
                                }}
                                options={companyList}
                              ></Select>
                            </div>
                            <div className="mb-3">
                              <Label htmlFor="employee" className="form-label">
                                Karyawan
                                {employeeLoading && (
                                  <Spinner color="primary" size="sm">
                                    Loading...
                                  </Spinner>
                                )}
                              </Label>
                              <Select
                                name="employee"
                                value={validation.values.employee}
                                placeholder="Enter Employee"
                                onChange={(e) => {
                                  validation.setFieldValue("employee", e);
                                  setLoanTermList([]);
                                  dispatch(resetLoanTermState());
                                  dispatch(
                                    getLoanTerm({
                                      companyId: e.companyId,
                                      status: 2,
                                    })
                                  );
                                }}
                                options={employeeList}
                                invalid={validation.touched.employee && validation.errors.employee ? true : false}
                              ></Select>
                              {validation.touched.employee && validation.errors.employee ? (
                                <p className="text-danger" type="invalid">
                                  {validation.errors.employee}
                                </p>
                              ) : null}
                            </div>
                            <div className="mb-3">
                              <Label htmlFor="termId" className="form-label">
                                Jangka Waktu Pinjaman
                                {loanTermLoading && (
                                  <Spinner color="primary" size="sm">
                                    Loading...
                                  </Spinner>
                                )}
                              </Label>
                              <Select
                                name="termId"
                                placeholder="Enter Loan"
                                value={validation.values.termId}
                                onChange={(e) => {
                                  validation.setFieldValue("termId", e);
                                  setAmount(e.amount);
                                  setMaxAmount(e.amount);
                                  setPeriod(e.period);
                                  setMaxPeriod(e.period);
                                  setInterest(e.interest);
                                  setInterestType(e.interest_type);
                                  validation.setFieldValue("period", e.period);
                                  validation.setFieldValue("amount", e.amount);
                                }}
                                options={loanTermList}
                                invalid={validation.touched.termId && validation.errors.termId ? true : false}
                              ></Select>
                              {validation.touched.termId && validation.errors.termId ? (
                                <p className="text-danger" type="invalid">
                                  {validation.errors.termId}
                                </p>
                              ) : null}
                            </div>
                            <Row>
                              <div className="mb-3 col-lg-6">
                                <Label htmlFor="period-field" className="form-label">
                                  Kredit Pinjaman (Bulan)
                                </Label>
                                <Input
                                  name="period"
                                  id="period-field"
                                  className="form-control"
                                  placeholder="Enter period"
                                  type="number"
                                  onFocus={(e) => e.target.select()}
                                  onChange={(e) => {
                                    let num = Number(e.target.value);
                                    if (num > maxPeriod) {
                                      validation.setFieldValue("period", maxPeriod);
                                      setPeriod(maxPeriod);
                                    } else {
                                      validation.setFieldValue("period", num);
                                      setPeriod(e.target.value);
                                    }
                                  }}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.period || 0}
                                  invalid={validation.touched.period && validation.errors.period ? true : false}
                                />
                                {validation.touched.period && validation.errors.period ? <FormFeedback type="invalid">{validation.errors.period}</FormFeedback> : null}
                              </div>
                              <div className="mb-3 col-lg-6">
                                <Label htmlFor="amount-field" className="form-label">
                                  Jumlah Pinjaman
                                </Label>
                                <Input
                                  name="amount"
                                  id="amount-field"
                                  className="form-control"
                                  placeholder="Enter amount"
                                  type="number"
                                  onFocus={(e) => e.target.select()}
                                  onChange={(e) => {
                                    let num = Number(e.target.value);
                                    if (num > maxAmount) {
                                      validation.setFieldValue("amount", maxAmount);
                                      setAmount(maxAmount);
                                    } else {
                                      validation.setFieldValue("amount", num);
                                      setAmount(num);
                                    }
                                  }}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.amount || 0}
                                  invalid={validation.touched.amount && validation.errors.amount ? true : false}
                                />
                                {validation.touched.amount && validation.errors.amount ? <FormFeedback type="invalid">{validation.errors.amount}</FormFeedback> : null}
                              </div>
                            </Row>
                            <div className="mb-3">
                              <Label htmlFor="date-field" className="form-label">
                                Tanggal Berlaku
                              </Label>
                              <Flatpickr
                                name="startat"
                                className="form-control"
                                placeholder="Select  date"
                                options={{
                                  enableTime: false,
                                  dateFormat: "Y/m/d",
                                }}
                                value={validation.values.startat ?? ""}
                                onChange={(o, e) => {
                                  validation.setFieldValue("startat", e);
                                }}
                              />
                              {validation.touched.startat && validation.errors.startat ? (
                                <p className="text-danger" type="invalid">
                                  {validation.errors.startat}
                                </p>
                              ) : null}
                            </div>

                            <div className="mb-4">
                              <Label htmlFor="description-field" className="form-label">
                                Keterangan
                              </Label>
                              <Input name="description" id="description-field" className="form-control" placeholder="Isi Keterangan" type="textarea" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.description ?? ""} />
                            </div>
                          </div>
                          <div className="col">
                            {/* //// */}
                            <table className="table border table-responsive table-striped fs-13 mb-3">
                              <thead className="table-light">
                                <tr>
                                  <th>Periode</th>
                                  <th>Jumlah</th>
                                  <th>Bunga</th>
                                  <th>total</th>
                                </tr>
                              </thead>
                              <tbody>
                                {instalmentData.map((instalment, i) => {
                                  return (
                                    <tr key={i}>
                                      <td>{Math.round(instalment.period)}</td>
                                      <td>{currencyFormat(instalment.amount)}</td>
                                      <td>{currencyFormat(instalment.interest)}</td>
                                      <td>{currencyFormat(instalment.total)}</td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                            {/* /// */}
                          </div>
                        </div>
                      </ModalBody>
                    )}
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                          }}
                        >
                          Tutup
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{"Simpan"}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="reason">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <Modal id="showModalAccPayment" isOpen={approveModal} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggleApprove}>
                    Persetujuan Pinjaman
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationAccPayment.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="mb-3 col-lg-12">
                          <Label htmlFor="amount-field" className="form-label">
                            Tanggal Transaksi
                          </Label>
                          <Flatpickr
                            className="form-control"
                            id="datepicker-publish-input"
                            placeholder="Select transaction date"
                            options={{
                              mode: "single",
                              dateFormat: "Y/m/d",
                            }}
                            onChange={(selectedDates, dateStr) => {
                              validationAccPayment.setFieldValue("transactionat", dateStr);
                            }}
                            value={validationAccPayment.values.transactionat ?? ""}
                          />
                          {validationAccPayment.touched.transactionat && validationAccPayment.errors.transactionat && (
                            <small className="text-danger" type="invalid">
                              {validationAccPayment.errors.transactionat}
                            </small>
                          )}
                        </div>
                        <div className="mb-3 col-lg-12">
                          <label className="form-label" htmlFor="account">
                            Pinjaman Dari Akun
                          </label>
                          <Select
                            name="account"
                            value={validationAccPayment.values.account}
                            placeholder="Enter account"
                            onChange={(e) => {
                              validationAccPayment.setFieldValue("account", e);
                            }}
                            options={accountingList}
                          ></Select>
                          {validationAccPayment.touched.account && validationAccPayment.errors.account && (
                            <small className="text-danger" type="invalid">
                              {validationAccPayment.errors.account}
                            </small>
                          )}
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            toggleApprove();
                          }}
                        >
                          Close
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">Menyetujui Pinjaman</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
              </CardBody>
            </Card>
          </Col>
          <Col sm={4}>
            <Card>
              <div className="card-body align-items-center mb-0">
                <h5 className="text-uppercase mb-2 flex-grow-1">Detail Pinjaman</h5>
                <p className="fs-16 mb-1">{info && info.loan_user && info.loan_user.name}</p>
                <p className="fs-14">{currencyFormat(info.amount)}</p>
              </div>
              <CardBody className="border border-top-0 border-end-0 border-start-0 mt-0">
                <div className="m-1 p-0">
                  <table className="table border table-responsive table-striped fs-12 mb-3 ">
                    <thead className="table-light">
                      <tr>
                        <th colSpan={2}>Periode</th>
                        <th>Jumlah</th>
                        <th>Bunga</th>
                        <th>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {info &&
                        info.loan_instalment &&
                        info.loan_instalment.map((instalment, i) => {
                          return (
                            <tr key={i}>
                              <td>{Math.round(instalment.period)}</td>
                              <td>{instalment.status && <span className="badge text-uppercase badge-soft-info">{instalment.status}</span>}</td>
                              <td>{currencyFormat(instalment.amount)}</td>
                              <td>{currencyFormat(instalment.interest)}</td>
                              <td>{currencyFormat(instalment.total)}</td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Loan;
